// extracted by mini-css-extract-plugin
export default {"root":"Ix7Nb","link-overlay":"rOyAs","linkOverlay":"rOyAs"};